import "./ProfileOptions.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * 
 * @returns sample page for privacy policy.
 */
const PrivacyPolicy = () => {
  return (
    <Box className="main sample-page-container">
      <Typography variant="h6" className="sample-page">
        This is the sample page. Here you can write about the privacy-policies
        of web-app.
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
